import {
    Component,
    ViewChild
} from '@angular/core';
import { Contact } from '../model/contact';
import { ReCaptchaComponent } from 'angular2-recaptcha';
import { IError } from '../model/types';

@Component({
    selector: 'contact-component',
    template: require('./contact.component.html'),
    styles: [require('./contact.component.css')]
})

export class ContactComponent {

    @ViewChild(ReCaptchaComponent) private captcha: ReCaptchaComponent;

    public message : string;
    public title   : string;
    public contact : string;
    public formSent : boolean = false;
    public errors : {errors: IError[]};

    constructor (
        private ContactResource : Contact
    ) {
        this.errors = null;
    }

    public send() {
        this.errors = null;
        if (this.captcha.getResponse()) {
            this.ContactResource.send({message: this.message, title: this.title, contact: this.contact})
                .$observable
                .subscribe(() => {
                    this.formSent = true;
                }, (response) => {

                    let errors = response.json();

                    if (errors.errors) {
                        this.errors = errors;
                    }
                });
        } else {
            this.errors = {errors: [{message: 'Klikkaa robottifiltteriä!', propertyPath: 'check'}]};
        }
    }
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/tslint-loader??ref--7-0!./src/app/contact/contact.component.ts